const ROUTE_BASE = import.meta.env.VITE_API_BASE_URL;

const ROUTE_USER_SHOW = 'user';
const ROUTE_USER_UPDATE = 'user';
const ROUTE_USER_DISCONNECT_BALE = 'user/disconnect-bale';

const ROUTE_LOGIN = 'login';
const ROUTE_REGISTER = 'register';
const ROUTE_LOGOUT = 'logout';

const ROUTE_VERSION = 'version';
const ROUTE_CONFIG = 'config';

const ROUTE_CITY_INDEX = 'city';

const ROUTE_FILE_UPLOAD = 'file/upload';
const ROUTE_FILE_DOWNLOAD = 'file/download';

const ROUTE_CATEGORY_INDEX = 'product/category';
const ROUTE_CATEGORY_SHOW = 'category/%i';
const ROUTE_CATEGORY_INDEX_TREE = 'product/category/tree';
const ROUTE_CATEGORY_INDEX_TREE_BY_WAREHOUSE = 'public/categories/warehouse-active-categories/%i';
const ROUTE_PUBLIC_CATEGORY_INDEX = 'public/categories';
const ROUTE_PUBLIC_CATEGORY_SHOW = 'public/categories/%i';

const ROUTE_VARIATION_TYPE_ITEM_INDEX = 'variation_type_item';

const ROUTE_TRANSACTION_INDEX = 'user/transaction';
const ROUTE_TRANSACTION_BALANCE = 'user/transaction/balance';
const ROUTE_TRANSACTION_WITHDRAWABLE_BALANCE = 'user/transaction/withdrawable-balance';

const ROUTE_WITHDRAW_REQUEST_STORE = 'user/withdraw-request';
const ROUTE_WITHDRAW_REQUEST_SHOW = 'user/withdraw-request/last-request';
const ROUTE_WITHDRAW_REQUEST_DESTROY = 'user/withdraw-request/last-request';

const ROUTE_USER_CHANGE_PASSWORD = 'user/password/change';

const ROUTE_PUBLIC_PRODUCT_VARIATION_INDEX = 'public/product-variations/per-warehouse';

const ROUTE_WAREHOUSE_SHOW = 'public/warehouses/%i';
const ROUTE_WAREHOUSE_SHOW_BY_SLUG = 'public/warehouses/by-slug/%s';

const ROUTE_ORDER_STORE = 'public/orders';
const ROUTE_ORDER_SHOW_BY_NUMBER = 'public/warehouses/%s/orders/number/%i';
const ROUTE_ORDER_SHOW_BY_MOBILE = 'public/orders/user-mobile/%s';

const ROUTE_TOP_PRODUCTS = 'public/top-products';
const ROUTE_PUBLIC_PRODUCT_INDEX = 'public/products';
const ROUTE_PUBLIC_PRODUCT_SHOW = 'public/products/%i';
const ROUTE_PUBLIC_PRODUCT_RELATED = 'public/products/%i/related';
const ROUTE_PUBLIC_WAREHOUSE_PRODUCT_INDEX = 'public/warehouses/%i/products';
const ROUTE_PUBLIC_WAREHOUSE_PRODUCT_SHOW = 'public/warehouses/%i/products/%i';

const ROUTE_REPORT_STORE = 'products/%i/reports';

export {
  ROUTE_BASE,
  ROUTE_CONFIG,
  ROUTE_USER_SHOW,
  ROUTE_USER_UPDATE,
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_VERSION,
  ROUTE_REGISTER,
  ROUTE_CITY_INDEX,
  ROUTE_CATEGORY_INDEX,
  ROUTE_TRANSACTION_INDEX,
  ROUTE_TRANSACTION_BALANCE,
  ROUTE_CATEGORY_INDEX_TREE,
  ROUTE_CATEGORY_SHOW,
  ROUTE_VARIATION_TYPE_ITEM_INDEX,
  ROUTE_FILE_DOWNLOAD,
  ROUTE_USER_DISCONNECT_BALE,
  ROUTE_WITHDRAW_REQUEST_STORE,
  ROUTE_WITHDRAW_REQUEST_SHOW,
  ROUTE_WITHDRAW_REQUEST_DESTROY,
  ROUTE_TRANSACTION_WITHDRAWABLE_BALANCE,
  ROUTE_USER_CHANGE_PASSWORD,
  ROUTE_FILE_UPLOAD,
  ROUTE_PUBLIC_WAREHOUSE_PRODUCT_INDEX,
  ROUTE_PUBLIC_WAREHOUSE_PRODUCT_SHOW,
  ROUTE_PUBLIC_PRODUCT_VARIATION_INDEX,
  ROUTE_WAREHOUSE_SHOW_BY_SLUG,
  ROUTE_ORDER_STORE,
  ROUTE_ORDER_SHOW_BY_NUMBER,
  ROUTE_ORDER_SHOW_BY_MOBILE,
  ROUTE_TOP_PRODUCTS,
  ROUTE_PUBLIC_PRODUCT_INDEX,
  ROUTE_PUBLIC_PRODUCT_SHOW,
  ROUTE_WAREHOUSE_SHOW,
  ROUTE_REPORT_STORE,
  ROUTE_PUBLIC_PRODUCT_RELATED,
  ROUTE_CATEGORY_INDEX_TREE_BY_WAREHOUSE,
  ROUTE_PUBLIC_CATEGORY_SHOW,
  ROUTE_PUBLIC_CATEGORY_INDEX,
};
